import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import { ErrorMessages } from "../../../../../../Constants";

// const POST_DATA = {
//   "businessunitid": null, // null,
//   "logoplacementtypeid": null, // 1,
//   "bodyplacementtypeid": null, // 1,
//   "signatureplacementtypeid": null, // 1,
// };

const POST_DATA = {
  roundofftypeid: null, // 2
};

export class SalaryCalculations extends React.Component {
  state = {
    postdata: get(this.props, "payrollconfigdata", "") || POST_DATA,
  };

  submit = () => {
    const { postdata } = this.state;
    if (postdata.roundofftypeid == null) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
      return;
    }
    instance
      .post("payroll/payrollmoreconfig", postdata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.getpayrollconfig();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  render() {
    const {
      postdata: { roundofftypeid },
    } = this.state;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.Misc.RoundingOption.header}</title>
        </Helmet>
        <Grid container>
          <Grid md={12} xs={12} lg={12} sm={12}>
            <div>
              <div className="margin-bottom-32 padding16 width55" style={{ background: "#f7f8f8" }}>
                <div className="small-dark-secondary">How would you like to round off salary calculations ?</div>
                <Grid container style={{ margin: "8px 0px", background: "white" }}>
                  <Grid md={4} xs={12} lg={4} sm={12}>
                    <div
                      className="cursor-pointer"
                      style={{
                        border: roundofftypeid == 1 ? "1px solid #1e8ced" : "1px solid #dcdcdc",
                        borderRadius: 5,
                        height: 67,
                        padding: 8,
                        margin: "8px 4px 8px 8px",
                        textAlign: "center",
                      }}
                      onClick={() => this.props.permissions && this.props.permissions.editable && this.setState({ postdata: { roundofftypeid: 1 } })}
                    >
                      <div style={{ fontWeight: "bold", fontSize: 10 }}>Two decimal places</div>
                      <div>
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>29.29</span>
                        <span style={{ fontWeight: "bold", fontSize: 18, color: "#d4d4d4" }}>3</span>
                      </div>
                      <div style={{ height: 20 }}>{roundofftypeid == 1 && <img src={CheckImg} alt="" height="20" />}</div>
                    </div>
                  </Grid>
                  <Grid md={4} xs={12} lg={4} sm={12}>
                    <div
                      className="cursor-pointer"
                      style={{
                        border: roundofftypeid == 2 ? "1px solid #1e8ced" : "1px solid #dcdcdc",
                        borderRadius: 5,
                        height: 67,
                        padding: 8,
                        margin: "8px 4px 8px 8px",
                        textAlign: "center",
                      }}
                      onClick={() => this.props.permissions && this.props.permissions.editable && this.setState({ postdata: { roundofftypeid: 2 } })}
                    >
                      <div style={{ fontWeight: "bold", fontSize: 10 }}>Round up to nearest integer</div>
                      <div>
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>30</span>
                      </div>
                      <div style={{ height: 20 }}>{roundofftypeid == 2 && <img src={CheckImg} alt="" height="20" />}</div>
                    </div>
                  </Grid>
                  <Grid md={4} xs={12} lg={4} sm={12}>
                    <div
                      className="cursor-pointer"
                      style={{
                        border: roundofftypeid == 3 ? "1px solid #1e8ced" : "1px solid #dcdcdc",
                        borderRadius: 5,
                        height: 67,
                        padding: 8,
                        margin: "8px 4px 8px 8px",
                        textAlign: "center",
                      }}
                      onClick={() => this.props.permissions && this.props.permissions.editable && this.setState({ postdata: { roundofftypeid: 3 } })}
                    >
                      <div style={{ fontWeight: "bold", fontSize: 10 }}>Round down to nearest integer</div>
                      <div>
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>29</span>
                      </div>
                      <div style={{ height: 20 }}>{roundofftypeid == 3 && <img src={CheckImg} alt="" height="20" />} </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>

            <Grid container>
              <Grid item xs={12} md={6} sm={12} style={{ justifyContent: "flex-start", display: "flex" }}>
                <div className="">
                  {this.props.permissions && this.props.permissions.editable && roundofftypeid != null && (
                    <Button className="btn btn-secondary-md-blue margin-right-8" variant="contained" onClick={this.submit}>
                      Save
                    </Button>
                  )}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(SalaryCalculations));
